import axios from 'axios'
import store from './store'
const instance = axios.create({
  //baseURL:'https://stopmtlapi.azurewebsites.net'
  baseURL:'https://api.stopmtl.com'
  
});

// // before a request is made start the nprogress
// instance.interceptors.request.use(config => {
//   store.commit('isLoading')
//   return config
// })
// // before a response is returned stop nprogress
// instance.interceptors.response.use(res => {
//     store.commit('isNotLoading')
//     return res;
//   }, error => {
//   if (error.response.status !== 200) {    
//     store.commit('isNotLoading')
//   }
//   //console.log(error);
// return error;
// });

export default instance


// WEBPACK FOOTER //
// ./src/axios-inst.js